module.exports = __webpack_public_path__ + "img/hondacivic.a6a0f929.png";